import { schema, normalize } from 'normalizr';
import { createRetailTransformers } from 'pages/store/transformers/retail';

export const entity = 'paymentType';
export const entitySchema = new schema.Entity(
  entity,
  {},
  {
    idAttribute: 'paymentTypeID',
  }
);
export const normalizer = result => normalize(result, entitySchema);
export const listNormalizer = result => normalize(result, [entitySchema]);

// Payment Type transformers
export const { transformer, listTransformer } = createRetailTransformers('PaymentType');
